import React from 'react';
import Accordion from 'components/Accordion';
import Snackbar from 'components/DesignSystem/Snackbar';
import useListPreferences from 'hooks/Meteorology/Agro/TrackingForecast/DetailedView/useListPreferences';
import useDeletePreference from 'hooks/Meteorology/Agro/TrackingForecast/DetailedView/useDeletePreference';
import Preference from './Preference';

export default function Preferences() {
  const { preferences } = useListPreferences();
  const { preferenceDeleteTrigger, isLoading } = useDeletePreference();

  return (
    <Accordion.Item eventKey="1">
      <Accordion.Header>Preferências Salvas</Accordion.Header>
      <Accordion.Body>
        {preferences.length === 0 && (
          <Snackbar className="mt-2">Nenhuma preferência disponível.</Snackbar>
        )}
        { preferences.map((preference) => (
          <Preference
            key={preference.id}
            preference={preference}
            onDelete={preferenceDeleteTrigger(preference.name)}
            deleteLoading={isLoading}
          />
        )) }
      </Accordion.Body>
    </Accordion.Item>
  );
}
